
export class SKpi {
    value: number;
    start: number;
}

